import { Extension } from "@tiptap/react";
import { v4 as uuidv4 } from "uuid";

export const AddUUID = Extension.create({
  addGlobalAttributes() {
    return [
      {
        types: ["heading", "paragraph", "table"],

        attributes: {
          "data-uuid": {
            default: "",
            renderHTML: (attributes) => {
              return { "data-uuid": attributes["data-uuid"] };
            },
            parseHTML: (element) => {
              if (element.dataset.uuid) {
                return {
                  "data-uuid": element.dataset.uuid,
                };
              } else {
                return {
                  "data-uuid": uuidv4(),
                };
              }
            },
          },
        },
      },
    ];
  },
});
